import React from 'react';
import { Logo } from '@app/ui/pages/landing-page/header/logo/logo.component';
import { Typography } from '@mui/material';
import {
  FooterInfoLogoWrapper,
  FooterInfoWrapper,
} from '@app/ui/pages/landing-page/footer/info/footer-info.styles';
import { PROVIDER_NAME_RU } from '@app/ui/common/common.constants';

export const FooterInfo: React.FC = () => {
  return (
    <FooterInfoWrapper>
      <FooterInfoLogoWrapper>
        <Logo />
      </FooterInfoLogoWrapper>
      <Typography variant='body1'>
        {PROVIDER_NAME_RU} - интернет-провайдер, предоставляющий услуги связи
        жителям частных и многоквартирных домов на территории калужской области.
      </Typography>
    </FooterInfoWrapper>
  );
};
